import React from 'react'
import { FaYoutube, FaFacebook, FaLinkedin } from "react-icons/fa";


const Footer = () => {
    return (
        <footer className="footer items-center p-4 bg-neutral text-neutral-content">
            <div className="items-center grid-flow-col">
                <img className="rounded-full" src="https://lh3.googleusercontent.com/a/ALm5wu0gKSbj-vrE-htx83t_56TBALi1t7_JwwWnxFh1gA=s96-c" alt="" />
                <p>Copyright © 2022 - All right reserved</p>
            </div>
            <div className="grid-flow-col gap-4 md:place-self-center md:justify-self-end items-center">
                <a>
                    <FaYoutube className="w-12 h-12"></FaYoutube>
                </a>
                <a>
                    <FaLinkedin className="w-12 h-12"></FaLinkedin>
                </a>
            </div>
        </footer>
    )
}

export default Footer
